import axios from 'axios';

async function createCompany(data) {
  const response = await axios.post('/companies', data);

  return response.data;
}

async function createCompanyDetails(companyId, data) {
  const response = await axios.post(`/companies/${companyId}/details`, data);

  return response.data;
}

async function deleteCompany(companyId) {
  const response = await axios.delete(`/companies/${companyId}`);

  return response.data;
}

async function getCompanyById(companyId) {
  const response = await axios.get(`/companies/${companyId}`);

  return response.data;
}

async function getCompanyDetails(companyId) {
  const response = await axios.get(`/companies/${companyId}/details`);

  return response.data;
}

async function getCompanyInformationBySiren(siren) {
  const response = await axios.get(`/company/legalInfos?siren=${siren}`);

  return response.data;
}

async function listCompanies() {
  const response = await axios.get('/companies');

  return response.data;
}

async function updateCompany(companyId, data) {
  const response = await axios.put(`/companies/${companyId}`, data);

  return response.data;
}

async function updateCompanyDetails(companyId, data) {
  const response = await axios.put(`/companies/${companyId}/details`, data);

  return response.data;
}

const companyService = {
  createCompany,
  deleteCompany,
  getCompanyById,
  createCompanyDetails,
  getCompanyDetails,
  getCompanyInformationBySiren,
  listCompanies,
  updateCompany,
  updateCompanyDetails,
};

export default companyService;
